<script setup lang="ts">
import * as lucideIcons from "lucide-vue-next";
import { SVGAttributes } from "vue";
import { getCspNonce } from '@/utils/csp';

export type Icon = keyof typeof lucideIcons;

interface LucideProps extends SVGAttributes {
    icon: Icon;
    title?: string;
}

const props = defineProps<LucideProps>();

// Get CSP nonce for SVG elements
const cspNonce = getCspNonce();
</script>

<template>
    <component
        :is="lucideIcons[props.icon]"
        class="stroke-2"
        :nonce="cspNonce"
    />
</template>
